/** @file Text-field key to commit, cancel or pass; Escape with nothing to undo is left to a dialog or menu. */

/** What the field should do for a key; 'pass' means the field does not consume it. */
export type TextKeyAction = 'commit' | 'cancel' | 'pass';

/**
 * Enter and NumpadEnter commit. Escape cancels when the text was edited (`dirty`) or the owner listens for
 * cancels (`cancellable`, for example a rename); otherwise it passes so a Dialog around the field can close.
 * Keys pressed during an IME composition always pass.
 */
export function textKeyAction(code: string, composing: boolean, dirty: boolean, cancellable: boolean): TextKeyAction {
  if (composing) return 'pass';
  if (code === 'Enter' || code === 'NumpadEnter') return 'commit';
  return code === 'Escape' && (dirty || cancellable) ? 'cancel' : 'pass';
}
